export function country2DCString (string) {
  switch (string) {
    case 'sg':
      return 'SAO'
    case 'in':
      return 'SIN'
    case 'br':
      return 'BOM'
    default:
      return ''
  }
}
